const root = '/dashboard/discovery'
export const forgeDestinations = [
  { key: 'summary', path: `${root}/overview`, group: 'project' },
  { key: 'objectives', path: `${root}/objectives`, group: 'project' },
  { key: 'tasks', path: `${root}/tasks`, group: 'project' },
  { key: 'knowledge', path: `${root}/workspace`, group: 'project' },
  { key: 'people', path: `${root}/people`, group: 'project' },
  { key: 'dashboards', path: '', group: 'project' },
  { key: 'decisions', path: `${root}/outcomes`, group: 'project' },
  { key: 'ontology', path: root, group: 'technical' },
  { key: 'data', path: `${root}/data`, group: 'technical' },
  { key: 'triggers', path: `${root}/triggers`, group: 'technical' },
  { key: 'investigations', path: `${root}/investigations`, group: 'technical' },
  { key: 'workflows', path: `${root}/workflows`, group: 'technical' },
  { key: 'settings', path: `${root}/settings`, group: 'settings' },
] as const
const sections: Record<string, string[]> = {
  overview: ['overview', 'project_objectives'],
  objectives: ['objectives'],
  tasks: ['tasks', 'project_tasks', 'project_task_comments', 'project_task_dispatches'],
  settings: ['settings', 'projects'],
  people: ['people', 'project_members', 'project_agents'],
  workspace: ['workspace', 'material', 'documents', 'repository_file', 'project_memory', 'timeline', 'timeline_events', 'calendar_connections', 'project_whatsapp_sources'],
  ontology: ['ontology_history', 'elements', 'ontology_classes', 'ontology_interfaces', 'link_types', 'action_types', 'process_maps', 'relationships', 'data_bindings', 'evidences'],
  data: ['data', 'semantic_objects'],
  triggers: ['triggers'],
  investigations: ['investigations'],
  workflows: ['workflows'],
  outcomes: ['outcomes', 'decisions'],
}

/** Resolve the parent section, including nested routes and query-based details. */
export function forgeNavigationPath(url: string): string | null {
  const [rawPath, query = ''] = url.split('?')
  const path = rawPath.replace(/\/$/, '')
  if (/^\/dashboard\/workflows(?:\/|$)/.test(path) && new URLSearchParams(query).has('project_id')) return `${root}/workflows`
  if (path === root) return root
  if (path === `${root}/projects`) return path
  if (!path.startsWith(`${root}/`)) return null
  const route = path.slice(root.length + 1).split('/')[0]
  if (route === 'elements' && new URLSearchParams(query).get('return_to') === 'people') {
    return `${root}/people`
  }
  const section = Object.keys(sections).find((key) => sections[key].includes(route))
  return section ? (section === 'ontology' ? root : `${root}/${section}`) : null
}

export function forgeProjectId(url: string, fallback?: string | null): string | null {
  if (url.split('?')[0] === `${root}/projects`) return null
  return url.match(/^\/dashboard\/projects\/([^/]+)\/dashboards(?:\/|\?|$)/)?.[1]
    || new URLSearchParams(url.split('?')[1] || '').get('project_id') || fallback || null
}

/** Preserve the section/view, never an object ID, file, source reference or old filters. */
export function forgeProjectSwitchUrl(url: string, projectId: string): string {
  if (/^\/dashboard\/projects\/[^/]+\/dashboards(?:\/|\?|$)/.test(url)) return `/dashboard/projects/${projectId}/dashboards`
  const previous = new URLSearchParams(url.split('?')[1] || '')
  let path = forgeNavigationPath(url) || `${root}/overview`
  if (path === `${root}/projects`) path = `${root}/overview`
  const query = new URLSearchParams({ project_id: projectId })
  if (path.endsWith('/tasks') && ['board', 'list', 'schedule', 'gantt'].includes(previous.get('view') || '')) query.set('view', previous.get('view')!)
  if (path.endsWith('/workspace')) {
    if (url.startsWith(`${root}/project_whatsapp_sources`)) path = `${root}/project_whatsapp_sources`
    else if (url.startsWith(`${root}/timeline`)) path = `${root}/timeline`
    else if (previous.get('view') === 'knowledge') query.set('view', 'knowledge')
  }
  if (path.endsWith('/people') && ['agents', 'access'].includes(previous.get('section_view') || '')) query.set('section_view', previous.get('section_view')!)
  return `${path}?${query}`
}
